import request from '@/utils/request'

const launch = slot => {
  return request({
    url: `/${slot}/launch`,
    method: 'get'
  })
}

export default {
  launch
}
